module.exports = __webpack_public_path__ + "img/cursor.2702e5f3.jpg";